import React, { useState } from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import TrademarkOverview from '../components/TrademarkOverview';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import ProcessSection from '../components/ProcessSection';
import PricingSection from '../components/PricingSection';
import IndustriesSection from '../components/IndustriesSection';
import BenefitsSection from '../components/BenefitsSection';
import TrustSignals from '../components/TrustSignals';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ContactPopup from '../components/ContactPopup';

export const HomePage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  return (
    <>
      <SEO 
        title="Trademark Registration Services | USPTO Filing Experts | Trademark Fashion Brand"
        description="Professional trademark registration services with 95% success rate. Expert USPTO filing, comprehensive searches, office action responses. Protect your brand with 1000+ trademarks filed. Starting at $45 + filing fee."
        keywords="trademark registration, USPTO filing, trademark search, brand protection, trademark attorney, federal trademark, register trademark, trademark application, office action response, trademark monitoring"
        canonical="/"
      />
      <div className="min-h-screen bg-[#FFF7ED]">
        <Header openPopup={openPopup} />
        <HeroSection openPopup={openPopup} />
        <AboutSection />
        <TrademarkOverview />
        <ServicesSection />
        <WhyChooseUs />
        <ProcessSection />
        <PricingSection openPopup={openPopup} />
        <IndustriesSection />
        <BenefitsSection />
        <TrustSignals />
        <FAQSection />
        <CTASection openPopup={openPopup} />
        <ContactSection openPopup={openPopup} />
        <Footer openPopup={openPopup} />
        <ContactPopup isOpen={isPopupOpen} onClose={closePopup} />
      </div>
    </>
  );
};

export default HomePage;
